import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class FileManagementUserType {
  public readonly key = 'FileManagementUserType';
  public readonly enrollTrackRole = EnrollTrackRole.FileManagement;
}
